<template>
	<full-page ref="fullpage" :options="options" class="am-home" :skip-init="false">
		<div class="section">
			<am-hero
				class="am-home__hero"
				:init="current == 'hero'"
				:titles="hero.titles"
				:text="hero.text"
				:background="hero.background"
				:image="hero.image"
			/>
		</div>

		<div class="section">
			<am-about
				class="am-home__about"
				:init="current == 'about'"
				:title="about.title"
				:text="about.text"
				:images="about.images"
				@gallery="$emit('gallery', $event)"
			/>
		</div>

		<div class="section">
			<am-album
				class="am-home__album"
				:init="current == 'album'"
				:images="album.images"
			/>
		</div>

<!-- 		<div class="section">
			<am-section
				class="am-home__section"
				:init="current == 'parque-das-americas'"
				:title="parqueDasAmericas.title"
				:text="parqueDasAmericas.text"
				:images="parqueDasAmericas.images"
				:illustration="parqueDasAmericas.illustration"
				:flip="false"
				@gallery="$emit('gallery', $event)"
			/>
		</div> -->

		<div class="section">
			<am-environment
				class="am-home__environment"
				:init="current == 'environment'"
				:items="environment"
				@gallery="$emit('gallery', $event)"
			/>
		</div>

		<div class="section">
			<am-section
				class="am-home__section"
				:init="current == 'chill'"
				:title="chill.title"
				:text="chill.text"
				:images="chill.images"
				:illustration="chill.illustration"
				:flip="false"
				@gallery="$emit('gallery', $event)"
			/>
		</div>

		<div class="section">
			<am-section
				class="am-home__section"
				:init="current == 'safety'"
				:title="safety.title"
				:text="safety.text"
				:images="safety.images"
				:illustration="safety.illustration"
				:flip="true"
				@gallery="$emit('gallery', $event)"
			/>
		</div>

		<div class="section">
			<am-section
				class="am-home__section"
				:init="current == 'lifestyle'"
				:title="lifestyle.title"
				:text="lifestyle.text"
				:images="lifestyle.images"
				:illustration="lifestyle.illustration"
				:flip="false"
				@gallery="$emit('gallery', $event)"
			/>
		</div>

		<div class="section">
			<am-section
				class="am-home__section"
				:init="current == 'sustainability'"
				:title="sustainability.title"
				:text="sustainability.text"
				:images="sustainability.images"
				:imagess="sustainability.imagess"
				:illustration="sustainability.illustration"
				:flip="true"
				@gallery="$emit('gallery', $event)"
			/>
		</div>

		<div class="section">
			<am-team
				class="am-home__team"
				:init="current == 'team'"
				:value="team"
			/>
		</div>

		<div class="section">
			<am-promote
				class="am-home__promote"
				:init="current == 'book'"
				:thumbnail="promote.thumbnail"
				:video="promote.video"
				:book="promote.book"
			/>
		</div>

		<div class="section">
			<am-section
				class="am-home__section"
				:init="current == 'parque-das-americas'"
				:title="parqueDasAmericas.title"
				:text="parqueDasAmericas.text"
				:images="parqueDasAmericas.images"
				:illustration="parqueDasAmericas.illustration"
				:flip="false"
				@gallery="$emit('gallery', $event)"
			/>
		</div>

		<div class="section">
			<am-location
				class="am-home__location"
				:init="current == 'location'"
				:value="location"
			/>
		</div>

		<div class="section">
			<am-timeline
				class="am-home__timeline"
				:init="current == 'timeline'"
				:title="timeline.title"
				:text="timeline.text"
				:background="timeline.background"
				:image="timeline.image"
			/>
		</div>

		<!-- <div  class="section">
			<am-blog
				class="am-home__blog"
				:init="current == 'blog'"
				:postsLoaded="blog.init"
				:titles="blog.titles"
				:text="blog.text"
				:background="blog.background"
				:posts="blog.posts"
			/>
		</div> -->

		<div class="section">
			<am-contact
				class="am-home__contact"
				:showroom="contact.showroom"
				:init="current == 'contact'"
				@submit="$emit('submit', $event)"
			/>
		</div>


		<div class="section">
			<am-footer
				class="am-home__footer"
				:init="current == 'footer'"
				@submit="$emit('submit', $event)"
			/>
		</div>

		<div class="whatsapp" @click="onClick(whatsapp)">
			<div class="whatsapp--icon"></div>
		</div>
	</full-page>
</template>

<script>
import AMHero from '@/components/organisms/AMHero'
import AMAbout from '@/components/organisms/AMAbout'
import AMEnvironment from '@/components/organisms/AMEnvironment'
import AMContact from '@/components/organisms/AMContact'
import AMSection from '@/components/organisms/AMSection'
import AMAlbum from '@/components/organisms/AMAlbum'
import AMTeam from '@/components/organisms/AMTeam'
import AMPromote from '@/components/organisms/AMPromote'
import AMLocation from '@/components/organisms/AMLocation'
import AMTimeline from '@/components/organisms/AMTimeline'
import AMBlog from '@/components/organisms/AMBlog'
import AMFooter from '@/components/organisms/AMFooter'

export default {
	components: {
		'am-hero': AMHero,
		'am-about': AMAbout,
		'am-environment': AMEnvironment,
		'am-contact': AMContact,
		'am-section': AMSection,
		'am-album': AMAlbum,
		'am-team': AMTeam,
		'am-promote': AMPromote,
		'am-location': AMLocation,
		'am-timeline': AMTimeline,
		'am-blog': AMBlog,
		'am-footer': AMFooter
	},

	props: {
		current: {
			type: String,
			default: 'about'
		},
		anchors: {
			type: Array,
			default: () => (['about'])
		},
		hero: {
			type: Object,
			default: () => ({})
		},
		about: {
			type: Object,
			default: () => ({})
		},
		environment: {
			type: Array,
			default: () => ([])
		},
		album: {
			type: Object,
			default: () => ({})
		},
		parqueDasAmericas: {
			type: Object,
			default: () => ({})
		},
		chill: {
			type: Object,
			default: () => ({})
		},
		safety: {
			type: Object,
			default: () => ({})
		},
		lifestyle: {
			type: Object,
			default: () => ({})
		},
		sustainability: {
			type: Object,
			default: () => ({})
		},
		team: {
			type: Array,
			default: () => ({})
		},
		promote: {
			type: Object,
			default: () => ({})
		},
		location: {
			type: Array,
			default: () => ([])
		},
		timeline: {
			type: Object,
			default: () => ({})
		},
		blog: {
			type: Object,
			default: () => ({})
		},
		contact: {
			type: Object,
			default: () => ({})
		},
		pageCurrent: {
			type: String,
			default: 'home'
		},
	},

	data: vm => ({
		fullpage: null,
		options: {
			anchors: vm.anchors,
			scrollBar: false,
			fitToSection: false,
			dragAndMove: 'vertical',
			// scrollingSpeed: 500,
			/* scrollOverflow: true, */
			paddingTop: '60px',
			touchSensitivity: 20,
			normalScrollElementTouchThreshold: 50,
			afterLoad: function(origin, destination, direction) {
				vm.$store.commit('navigation/setCurrent', destination.anchor);
				/* console.log(" - setCurrent called -");
				console.log(destination.anchor); */
				/* this.fullpageMoveTo(destination.anchor); */

			}
		}
	}),

	watch: {
		current(value) {
			this.fullpageMoveTo(value);
			console.log(value);
		}
	},

	componentsReady() {
	this.fullpage.init();

  },
	methods: {
		fullpageMoveTo(value) {
			if (this.fullpage){
				this.fullpage.moveTo(value);
				/* console.log(" - current changed -");
				console.log(value); */
			}
		}
	},
	mounted() {
		this.fullpage = this.$refs.fullpage.api;

		/* this.fullpageMoveTo("blog"); */
	}
}
</script>

<style lang="scss">
.am-home{
	&__hero,
	&__about,
	&__section,
	&__album,
	&__environment,
	&__team,
	&__promote,
	&__location,
	&__timeline,
	&__blog,
	&__contact{
		height: 100%;
		clear: both;
	}

	@include grid-media($desktop-grid) {
		&__footer{
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
		}
	}
}
</style>
